export default __webpack_public_path__ + "c3ab95d78cd796c5bfdd3d46525ec026.svg";